import { Box, SimpleGrid, Text, Stack, Flex, LinkBox, LinkOverlay, Button } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import pressReleasesCard from '../../ui/press-releases-card.jpg';
import investorsCard from '../../ui/investors-card.jpg';

const GridCard = ({ title, subTitle, backgroundImage, href }) => {
  return (
        <Stack align="center">
          <Flex h={'300px'}
                w={'546px'}
                justify={'center'}
                align={'center'}
                bgImage={`linear-gradient(rgba(0, 0, 0, 0.4),rgba(0, 0, 0, 0.4)) , url(${backgroundImage})`}
                bgSize={'cover'}
                bgRepeat={'no-repeat'}
                borderRadius={10}
          >
            <Text color={'white'} fontWeight={'bold'} fontFamily={'GerTT'} fontSize={'24px'} opacity={1.0}>{title}</Text>
          </Flex>
        <Text>{subTitle}</Text>
        <LinkBox as='a'>
          <LinkOverlay href={href} isExternal>
            <Button bg="#333" color="white" size="lg" rightIcon={<ExternalLinkIcon />}>Read More</Button>
          </LinkOverlay>
        </LinkBox>
      </Stack>
  );
};

export default function SimpleTwoColumns() {
  return (
    <Box p={4}>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
        <GridCard
          title="PRESS RELEASES"
          subTitle="View our latest company press releases."
          backgroundImage={pressReleasesCard}
          href="https://investor.columbia.com/news-events/press-releases"
        />
        <GridCard
          title="INVESTOR RELATIONS"
          subTitle="Information for stockholders, potential investors and financial analysts."
          backgroundImage={investorsCard}
          href="https://investor.columbia.com/"
        />
      </SimpleGrid>
    </Box>
  );
}
